module.exports = __webpack_public_path__ + "img/tarj2-5.46b32809.svg";